export const initialMonitorsAndIssuesState = {
    monitorsById: {},
    monitorIdsByProjectId: {},
    issuesById: {},
    issueIdsByProjectId: {},
    commentsById: {},
    commentIdsByIssueId: {},
};
